import type { Models } from '@rematch/core';
import UserModel from './user';
import LocaleModel from './locale';
import GlobalModel from './global';

export interface RootModel extends Models<RootModel> {
  UserModel: typeof UserModel;
  LocaleModel: typeof LocaleModel;
  GlobalModel: typeof GlobalModel;
}

export const models: RootModel = {
  UserModel,
  LocaleModel,
  GlobalModel
};

//https://rematchjs.org/docs/api-reference/store/#configuration
